import { render, staticRenderFns } from "./ClienteFormView.vue?vue&type=template&id=016114d9&scoped=true"
import script from "./ClienteFormView.vue?vue&type=script&lang=js"
export * from "./ClienteFormView.vue?vue&type=script&lang=js"
import style0 from "./ClienteFormView.vue?vue&type=style&index=0&id=016114d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016114d9",
  null
  
)

export default component.exports